import type {ApplyVacancyRequest, ApplyVacancyResponse} from '../../http';
import {applyVacancy} from '../../http';
import {useMutation, useQueryClient} from 'react-query';

export function useApplyVacancy() {
	const queryClient = useQueryClient();

	return useMutation<ApplyVacancyResponse, unknown, ApplyVacancyRequest>({
		mutationFn: async (body) => {
			const {data} = await applyVacancy(body);
			return data;
		},
		onSuccess: (vacancy) => {
			queryClient.setQueryData(['vacancy', vacancy.id], vacancy);
			queryClient.invalidateQueries({queryKey: ['vacancies']});
		},
	});
}
